import { POWER_PERIODS } from '@/constants/supplyRates'
import { normalizeContractCups, isValidContractCups } from '@/services/contractCups'
import { emptyRatesForm, ratesPayload, validatePowers } from '@/services/estateSupplyRates'

export const COMMUNITY_LOCATION_FIELDS = ['address', 'postal_code', 'municipality', 'province']

export const emptyCommunitySupplyBlock = (location = {}) => ({
  company: '', iban: '',
  address: location.address || '',
  postal_code: location.postal_code || '',
  municipality: location.municipality || '',
  province: location.province || '',
  cups_light: '', cups_gas: '',
  ...emptyRatesForm(),
})

const clean = (value) => {
  const text = typeof value === 'string' ? value.trim() : value
  return text === '' || text === undefined ? null : text
}

export const communitySupplyBlockPayload = (block) => ({
  company: clean(block.company),
  iban: block.iban ? String(block.iban).replace(/\s+/g, '').toUpperCase() : null,
  ...Object.fromEntries(COMMUNITY_LOCATION_FIELDS.map((field) => [field, clean(block[field])])),
  cups_light: normalizeContractCups(block.cups_light) || null,
  cups_gas: normalizeContractCups(block.cups_gas) || null,
  ...ratesPayload(block),
})

export const communitySupplyBlocksPayload = (blocks) => blocks.map(communitySupplyBlockPayload)

export const validateCommunitySupplyBlock = (block) => {
  const errors = {}
  if (!String(block.address || '').trim()) errors.address = 'property.communityForm.validation.required'
  if (block.postal_code && !/^\d{4,5}$/.test(String(block.postal_code).trim())) {
    errors.postal_code = 'property.communityForm.validation.postalCode'
  }
  if (block.iban && !/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(String(block.iban).replace(/\s+/g, '').toUpperCase())) {
    errors.iban = 'property.communityForm.validation.iban'
  }
  for (const field of ['cups_light', 'cups_gas']) {
    const cups = normalizeContractCups(block[field])
    if (cups && !isValidContractCups(cups)) errors[field] = 'property.estateSupplies.validation.cups'
  }
  if (!normalizeContractCups(block.cups_light) && !normalizeContractCups(block.cups_gas)) {
    errors.cups_light = 'property.communityForm.validation.cupsRequired'
    errors.cups_gas = 'property.communityForm.validation.cupsRequired'
  }
  return { ...errors, ...validatePowers(block) }
}

export const validateCommunitySupplyBlocks = (blocks) => {
  const errors = {}
  blocks.forEach((block, index) => {
    Object.entries(validateCommunitySupplyBlock(block)).forEach(([field, key]) => {
      errors[`supplies.${index}.${field}`] = key
    })
  })
  for (const field of ['cups_light', 'cups_gas']) {
    const seen = new Map()
    blocks.forEach((block, index) => {
      const cups = normalizeContractCups(block[field])
      if (!cups) return
      if (seen.has(cups)) {
        for (const at of [seen.get(cups), index]) {
          errors[`supplies.${at}.${field}`] ??= 'property.communityForm.validation.duplicateCups'
        }
      } else {
        seen.set(cups, index)
      }
    })
  }
  return errors
}

export { POWER_PERIODS }
